import axios from "axios";
import authHeader from "./auth-header";
import Config from "../config/index";

class UserHistoryService {
  async getHistory() {
    const response = await axios.get(Config.apiBasePath + "/getHistory", {
      headers: authHeader(),
    });
    return response;
  }

  async getPaginatedUserHistory(param) {
    const response = await axios.post(
      Config.apiBasePath + "/getPaginatedUserHistory", null,
      { headers: authHeader(), params: param }
    );
    return response;
  }

  async saveBeforeLogout(data) {
    const response = await axios.post(
      Config.apiBasePath + "/saveHistory",
      data,
      { headers: authHeader() }
    );
    return response;
  }
}

export default new UserHistoryService();
